const requiredEnvKeys = ["REACT_APP_BASE_URL", "REACT_APP_WHATSAPP_NUMBER"];

export const validateEnv = () => {
  const missing = requiredEnvKeys.filter((key) => !process.env[key]);
  if (!missing.length) return;

  const message = `Missing required env variables: ${missing.join(", ")}`;

  // Fail-fast in production build/runtime.
  if (process.env.NODE_ENV === "production") {
    throw new Error(message);
  }

  // In development, surface clearly without crashing local iteration.
  // eslint-disable-next-line no-console
  console.warn(message);
};

